"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const Paper = (0, material_1.styled)(material_1.Paper)({ padding: "16px 24px" });
const Indicator = (0, material_1.styled)(material_1.Tabs)({
    height: 5,
    borderBottom: "1px solid #e4e4e4",
});
const TabView = ({ tabs, onTabChange, title, tabIndex = 0, children, variant, TabIndicatorProps, }) => {
    const [value, setValue] = (0, react_1.useState)(tabIndex);
    return (react_1.default.createElement(Paper, { "data-print": "no-padding-bottom" },
        children,
        react_1.default.createElement(material_1.Typography, { variant: "h6" }, title),
        react_1.default.createElement(Indicator, { indicatorColor: "primary", value: value, onChange: (_, newValue) => {
                setValue(newValue);
                if (onTabChange)
                    onTabChange(newValue);
            }, variant: variant, "data-report": "hide-on-print", TabIndicatorProps: TabIndicatorProps }, tabs.map(({ title: tabTitle }) => (react_1.default.createElement(material_1.Tab, { key: `${tabTitle}-tab`, label: tabTitle })))),
        tabs.map(({ content }, index) => {
            const id = `tab-content-${index}`;
            return (react_1.default.createElement("div", { role: "tabpanel", key: id, id: id, "aria-labelledby": id }, value === index && react_1.default.createElement("div", null, content)));
        })));
};
exports.default = TabView;
